"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ActionNamespaces = require("../actions/ActionNamespaces");

var _dispatcher = _interopRequireDefault(require("dispatcher/dispatcher"));

var _ImportsAPI = require("./ImportsAPI");

var _definePooledObjectStore = require("../flux/definePooledObjectStore");

var _registerPooledObjectService = _interopRequireDefault(require("../flux/registerPooledObjectService"));

(0, _registerPooledObjectService.default)({
  actionTypePrefix: _ActionNamespaces.IMPORT_NAMES,
  fetcher: _ImportsAPI.fetchImportNamesByIds
});

var _default = (0, _definePooledObjectStore.definePooledObjectStore)({
  actionTypePrefix: _ActionNamespaces.IMPORT_NAMES
}).defineName('ImportNamesStore').register(_dispatcher.default);

exports.default = _default;
module.exports = exports.default;